import { render, staticRenderFns } from "./K4Result.vue?vue&type=template&id=0fbc4efb"
import script from "./K4Result.vue?vue&type=script&lang=js"
export * from "./K4Result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports